import React from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, Flex } from '@chatterbug/aaron'

import CEFRSeal from 'src/components/CEFRSeal/CEFRSeal'

const CourseList = ({ items, onClick, course, currentCefrLevel }) => {
  return (
    <Grid
      as="ul"
      gridGap="1x"
      pb={{ _: '2x' }}
      pt={{ _: '0', tablet: '2x' }}
      px={{ _: '1x', tablet: '1x' }}
      position="relative"
    >
      {items.map((option) => {
        return (
          <Flex
            as="button"
            alignItems="center"
            aria-label={`${option.code}: ${option.label}`}
            onClick={() => onClick(option)}
            sx={{
              transition: `background-color 0.25s ease`,
              backgroundColor:
                option?.code === currentCefrLevel?.code
                  ? 'gray95'
                  : 'transparent',
              py: '0,5x',
              px: '1x',
              borderRadius: '1,5x',

              borderWidth: '0',
              color: 'black19',
              ':hover, :active, :focus': {
                backgroundColor: 'gray95',
              },
              ':focus': {
                boxShadow: 'darkFocusRing',
                outline: 'none',
              },
            }}
            key={option.code}
          >
            <Box width="24px" height="24px" mr="1x">
              <CEFRSeal
                cefrLevel={option.code}
                progress={option?.cefrLevelProgress}
              />
            </Box>
            <Box
              as="p"
              textAlign="left"
              fontSize="xs"
              fontWeight={option.code === course.code ? 'bold' : 'normal'}
            >
              {option.label}
            </Box>
          </Flex>
        )
      })}
    </Grid>
  )
}

const cefrLevelShape = PropTypes.shape({
  code: PropTypes.string,
  label: PropTypes.string,
})

CourseList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      cefrLevelProgress: PropTypes.number,
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  course: cefrLevelShape,
  currentCefrLevel: cefrLevelShape,
}

export default CourseList
